import { ErrorTypes, Operation, UploadType } from './upload.types';

export const PRIMARY_COLOR = '#F28E19';
export const DISABLED_COLOR = '#E5E5E5';

export const ERROR_TYPES: ErrorTypes = {
  MISSING_FIELD: {
    color: 'FFFF0000',
    label: 'Champ manquant',
  },
  DUPLICATE: {
    color: 'FFFFA500',
    label: 'Duplication',
  },
  PHONE: {
    color: 'FFFFFF00',
    label: 'Téléphone invalide',
  },
  INVALID_HEADER: {
    color: 'FFFF0000',
    label: 'En-tête invalide',
  },
  EXISTING_MATRICULE: {
    color: 'FF800080',
    label: 'Matricule existant',
  },
};

export const OPERATIONS: Operation[] = [
  {
    label: UploadType.INSCRIPTION,
    templateUrl: 'content/templates/inscription_eleves.xlsx',
    instructions: "Remplissez le template avec les informations d'inscription.",
    schema: [
      'Ancien Matricule',
      'Nouveau Matricule',
      'Nom',
      'Prénom',
      'Classe',
      'Nom du Parent',
      'Prénom du Parent',
      'Téléphone du Parent',
      'Montant de Scolarité',
      "Montant d'inscription",
    ],
    description: 'Gérez les inscriptions pour une année scolaire.',
  },

  {
    label: UploadType.MISE_A_JOUR,
    templateUrl: 'content/templates/update_eleves.xlsx',
    instructions: 'Remplissez le template avec les informations mises à jour des élèves existants.',
    schema: [
      'Ancien Matricule',
      'Nouveau Matricule',
      'Nom',
      'Prénom',
      'Classe',
      'Nom du Parent',
      'Prénom du Parent',
      'Téléphone du Parent',
      'Montant de Scolarité',
      "Montant d'inscription",
    ],
    description: 'Utilisez cette option pour modifier les informations des élèves existants.',
  },
];
